import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, DollarSign, BarChart, PieChart } from 'lucide-react';

const PopularCalculators = () => {
  const popularCalcs = [
    { id: 1, name:'ROI Calculator', icon: TrendingUp, color: 'text-green-500', link: '/calculators/return-on-investment' },
    { id: 2, name: 'Conversion Rate Calculator', icon: DollarSign, color: 'text-blue-500', link: '/calculators/conversion-rate' },
    { id: 3, name: 'Customer Lifetime Value', icon: BarChart, color: 'text-purple-500', link: '/calculators/customer-lifetime-value' },
    { id: 4, name: 'A/B Test Significance', icon: PieChart, color: 'text-orange-500', link: '/calculators/ab-test-significance' },
  ];

  return (
    <section className="my-12">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">Popular Calculators</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {popularCalcs.map(calc => (
          <Link key={calc.id} to={calc.link} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
            <calc.icon className={`w-12 h-12 ${calc.color} mb-4`} />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{calc.name}</h3>
            <span className="text-indigo-600 font-medium">Use Calculator</span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PopularCalculators;
